import { useEffect } from "react";

// Standaardwaarden uit public/index.html (die ziet elke crawler, ook zonder JavaScript)
const SITE = "Resto-Online";
const DEFAULT_DESCRIPTION =
   "Eigen webshop voor je restaurant, brasserie of traiteur. Gasten bestellen vooraf, kiezen afhalen of levering en betalen online. Zonder commissie.";

function setTag(selector, create, value) {
   let el = document.head.querySelector(selector);
   if (value == null) {
      el?.remove();
      return;
   }
   if (!el) {
      el = create();
      document.head.appendChild(el);
   }
   el.setAttribute(el.tagName === "LINK" ? "href" : "content", value);
}

const meta = (attr, key) => () => {
   const el = document.createElement("meta");
   el.setAttribute(attr, key);
   return el;
};

/**
 * Titel, beschrijving en canonical per pagina. Google leest deze na het renderen;
 * deelvoorbeelden (WhatsApp, Facebook) lezen enkel index.html.
 */
export default function usePageMeta({ title, description = DEFAULT_DESCRIPTION, canonical = null, noindex = false } = {}) {
   useEffect(() => {
      if (title === undefined) return;
      const previous = document.title;
      document.title = title ? `${title}` : SITE;
      setTag('meta[name="description"]', meta("name", "description"), description);
      setTag('meta[property="og:title"]', meta("property", "og:title"), document.title);
      setTag('meta[property="og:description"]', meta("property", "og:description"), description);
      setTag(
         'link[rel="canonical"]',
         () => {
            const el = document.createElement("link");
            el.setAttribute("rel", "canonical");
            return el;
         },
         canonical
      );
      setTag('meta[name="robots"]', meta("name", "robots"), noindex ? "noindex" : null);
      return () => {
         // Een pagina zonder eigen meta erft geen canonical/noindex van de vorige
         document.title = previous;
         document.head.querySelector('link[rel="canonical"]')?.remove();
         document.head.querySelector('meta[name="robots"]')?.remove();
      };
   }, [title, description, canonical, noindex]);
}

export { SITE, DEFAULT_DESCRIPTION };
